<template>
    <div component_name="CoursewareUpload" :component_id="id">
		<button class="btn btn-primary btn-sm" type="button" @click="showUploadWindow">上传</button>
        <input type="file" :ref="refId" @change="selectedFile" style="display: none">
    </div>
</template>
<script>
    /**
     * 组件名称：课件文件上传按钮组件
     * 特性
     *  1、注意此组件不提供v-model操作，因为此组件通常不可直接参与表单提交
     *  2、必须为该组件设置唯一ID
	 * 	3、注意：该组件会将文件直接上传到服务器，并在回调方法中返回一个URL地址
     */
    export default {
        name:"CoursewareUpload",
        props:{
            accept:{
                type:Array,
                required:false
            },
            limitSize:{//单位:字节
                type:Number,
                required:false
            },
            id:{//组件唯一ID
                type:String,
                default:null
            }
        },
        data:function(){
            return {
                input_file_name:'',
                refId:null
            }
        },
        created:function(){
            if(!this.id){
                alert('!ERROR:必须为CoursewareUpload组件设置唯一ID');
            }
            this.refId = 'ref_file_courseware_upload_btn'+this.id;
        },
        mounted:function(){
            
        },
        methods:{
            selectedFile:function(){
                let file = this.$refs[this.refId].files[0];
				this.input_file_name = file.name;
                //判定文件的后缀
                if(this.accept){
                    let index = this.input_file_name.lastIndexOf(".");
                    let suffix = this.input_file_name.substring(index+1);
                    let check = this.accept.filter(x=>x.toLowerCase() == suffix.toLowerCase());
                    if(!check || check.length == 0){
                        this.$error('文件格式错误,不支持的文件扩展名:'+suffix);
                        return;
                    }
                }
                //判定文件的大小
                if(this.limitSize){
                    if(file.size>this.limitSize){
                        this.$error('文件大小超过限制');
                        return;
                    }
                }
               //上传文件到服务器
			   if(file.size == 0){
			       this.$error('文件大小不能够是0字节');
			       return;
			   }
			   else{
			       let formdata = new FormData();
			       formdata.append("file",file);
			       this.$http.post("/htgl/common/uploadKj",formdata,{'Content-Type':'multipart/form-data'}).then(res=>{
			           if(res && res.code==0){
			               this.$emit('uploadSuccess',res.data);
			               console.log('-------res for uplaod image:',res.data);
			           }
			       })
			   }
            },
            showUploadWindow:function(){
                this.$refs[this.refId].dispatchEvent(new MouseEvent('click'));
            }

        }
    }
</script>